import React from 'react';
import { Helmet } from 'react-helmet-async';
import ServiceSidebar from './ServiceSidebar';
import './Service.css';

const ICSI = () => {
  return (
    <div className="service-page">

      {/* ✅ SEO START */}
      <Helmet>
        <title>ICSI Treatment in Ambala | Male Infertility Solution | Amaanat IVF</title>

        <meta
          name="description"
          content="Advanced ICSI treatment in Ambala at Amaanat IVF. Effective solution for male infertility, low sperm count, and IVF failure cases."
        />

        <link rel="canonical" href="https://amaanativf.com/services/icsi" />

        {/* ✅ Medical Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalProcedure",
            "name": "ICSI Treatment",
            "description": "Intracytoplasmic Sperm Injection for male infertility",
            "procedureType": "Therapeutic",
            "bodyLocation": "Reproductive system",
            "location": {
              "@type": "MedicalClinic",
              "name": "Amaanat IVF",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Ambala",
                "addressCountry": "India"
              }
            }
          })}
        </script>

        {/* ✅ FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What is ICSI treatment?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "ICSI is an advanced IVF technique where a single sperm is injected directly into an egg to achieve fertilization."
                }
              },
              {
                "@type": "Question",
                "name": "Who needs ICSI?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "ICSI is recommended for men with low sperm count, poor motility, or previous IVF failures."
                }
              },
              {
                "@type": "Question",
                "name": "Is ICSI better than IVF?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "ICSI is a specialized form of IVF and is more effective in cases of male infertility."
                }
              }
            ]
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* HERO */}
      <section className="service-hero">
        <div className="container">

          <h1>ICSI Treatment in Ambala</h1>

          <p>
            Advanced IVF technique for male infertility treatment
          </p>

          {/* <div className="hero-stats">
            <span>100%+</span> Fertilization Rate
          </div> */}

        </div>
      </section>

      {/* MAIN */}
      <div className="services-layout container">

        <ServiceSidebar />

        <div className="services-content">

          <section>
            <h2>What is ICSI Treatment?</h2>
            <p>
              ICSI (Intracytoplasmic Sperm Injection) is an advanced IVF
              procedure where a single sperm is directly injected into an egg.
              It is mainly used in cases of male infertility.
            </p>
          </section>

          <section>
            <h2>Who Needs ICSI Treatment?</h2>
            <ul>
              <li>Low sperm count (Oligospermia)</li>
              <li>Poor sperm motility</li>
              <li>Previous IVF failure</li>
              <li>Genetic fertility issues</li>
            </ul>
          </section>

          <section>
            <h2>ICSI Procedure Explained</h2>
            <p>
              The procedure involves selecting a healthy sperm and injecting it
              directly into the egg under a microscope to achieve fertilization.
            </p>
          </section>

          {/* ✅ Hidden SEO Block */}
          <section style={{ marginTop: "40px" }}>
            <h2>Best ICSI Treatment Centre in Ambala</h2>
            <p>
              Amaanat IVF provides advanced ICSI treatment in Ambala for male infertility cases.
              With expert embryologists and modern IVF lab technology, we ensure higher fertilization
              success rates and personalized fertility care.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default ICSI;